import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {deleteInsight, getInsights} from "../../actions/NewsPages";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {IMAGE_URL} from "../../path";

function InsightsList() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const [insights, setInsights] = useState<any[]>([])

    const handleDelete = async (postId: number) => {
        if (window.confirm("Are you sure you want to delete this webinar?")) {
            try {
                await deleteInsight(postId);
                // After successful delete, reload the data
                fetchInsights();
            } catch (error) {
                console.error("Failed to delete webinar:", error);
                alert("Failed to delete the webinar. Please try again.");
            }
        }
    };

    const fetchInsights = () => {
        getInsights()
            .then(response => {
                setInsights(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch news stories:", error);
            });
    }

    useEffect(() => {
        fetchInsights()
    }, []);

    return <div>
        <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user}/>
        <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />
        <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>
            <div className="content-form-button right-align">
                <button
                    type="button"
                    className="button button-right"
                    onClick={() => navigate('/dashboard/insights/create', { state: { user } })}
                >
                    Add New Insight
                </button>
            </div>
            <div className="table-container">
                <div className="table-container">
                    <table className="news-table">
                        <thead>
                        <tr>
                            <th style={{ width: "50%" }}>Title</th>
                            <th style={{ width: "30%" }}>Cover Image</th>
                            <th style={{ width: "20%" }}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {insights.map((post) => (
                            <tr key={post.id}>
                                <td>{post.title}</td>
                                <td>
                                    {post.image ? (
                                        <img
                                            src={IMAGE_URL + post.image}
                                            alt="Cover Image"
                                            style={{
                                                width: "100%",
                                                maxHeight: "120px",
                                                objectFit: "cover",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    ) : (
                                        <span>No image</span>
                                    )}
                                </td>
                                <td>
                                    <button
                                        className="button small"
                                        onClick={() => navigate(`/dashboard/insights/${post.id}/edit`, { state: { user } })}
                                        style={{ marginRight: "10px" }}
                                    >
                                        View / Edit
                                    </button>
                                    <button
                                        className="button small danger"
                                        onClick={() => {
                                            handleDelete(post.id)}
                                        }

                                        style={{ color: "black" }}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
}

export default InsightsList;
